<template>
	<div class="flex flex-col content-evenly items-center">
		<div class="h-full w-full">
			<div class="contained-section flex h-full flex-col justify-between">
				<div>
					<div class="mt-4 text-left">
						<h2
							class="mb-4 bg-gradient-to-br from-sky-600 to-violet-600 bg-clip-text text-transparent"
						>
							Business
						</h2>
						<p class="text-lg">Simplified business solution</p>
					</div>

					<div
						class="justify-left mt-6 flex w-full lg:h-36 xl:h-auto"
					>
						<TickList
							:items="items"
							icon-color="text-blue-400"
							class="m-0 text-lg"
						/>
					</div>
				</div>

				<div class="mt-8">
					<div class="flex flex-col gap-2 md:flex-row lg:flex-col">
						<CarbarLink
							href="/business"
							class="mx-0"
							:underline="false"
						>
							<CarbarButton
								:is-full-width="true"
								background-color="bg-blue-400 hover:bg-sky-600"
							>
								See our products
							</CarbarButton>
						</CarbarLink>

						<CarbarLink
							href="/business/fleet-subscription"
							:underline="false"
						>
							<CarbarButton
								:is-full-width="true"
								:is-outline="true"
							>
								Benefits of a fleet subscription
							</CarbarButton>
						</CarbarLink>
					</div>
					<TermsAndConditions
						:is-full-width="false"
						custom-class="text-center md:text-left lg:text-center mt-4 sm:mx-auto lg:mx-0"
					>
						<CarbarLink
							text="Terms & conditions"
							text-color="text-gray-625"
							font-size="text-xsm"
							class="cursor-pointer"
							href="/terms-and-conditions/car-subscription"
						/>
						apply
					</TermsAndConditions>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import TickList from '@/components/lists/TickList.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'

const items = [
	{
		label: 'Cost-effective solutions',
	},
	{
		label: 'Flexibility and  optimisation',
	},
	{
		label: 'Maintenance and support',
	},
]
</script>
